import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col mt-4 overflow-hidden" }
const _hoisted_2 = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_3 = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }
const _hoisted_4 = { class: "overflow-hidden border-b border-gray-200 shadow sm:rounded-lg" }
const _hoisted_5 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-50" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " 名前 "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " タイトル "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
    }, " 投票 ")
  ])
], -1)
const _hoisted_7 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_8 = { class: "px-6 py-4 text-gray-500 whitespace-nowrap" }
const _hoisted_9 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_10 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("tbody", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries, (entry) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: entry.id
                }, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(entry.salon_name) + _toDisplayString(entry.staff_name), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(entry.title), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(entry.vote_count) + "票 ", 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}